module.exports = __webpack_public_path__ + "static/galxe-6eb1737aff49f0024d14623d9e5e4814.png";